import * as React from "react";
const SvgCheckboxPiqk = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 0.5, width: 19, height: 19, rx: 5.5, fill: "currentColor", stroke: "#D1D5DB" }));
export default SvgCheckboxPiqk;
